import React, { useEffect, useState } from 'react'
import { CircleCheckIcon } from '../../../Icons/CircleCheckIcon'
import { StyledCircleCheckIconWrapper } from '../../../LocalReceipts/Form/ProgressChecks/StyledCircleCheckIconWrapper'
import { useTranslation } from 'react-i18next'
import { isEmptyGuid } from '../../../../utils/emptyGuid'

const HeaderCheck = ({ headerData }) => {
  const [isValid, setIsValid] = useState(false)
  const { t } = useTranslation()

  useEffect(() => {
    if (!!headerData.number && !isEmptyGuid(headerData.storehouse.id)) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [headerData])

  return (
    <>
      <StyledCircleCheckIconWrapper>
        <CircleCheckIcon variant={isValid ? 'done' : 'must'} />
      </StyledCircleCheckIconWrapper>
      <span>{t('returnsReceiptOverlayProgress:headerData')}</span>
    </>
  )
}

export default HeaderCheck
